import { STAGE0 } from 'constants/FarmboxConstants/stage0.constants';
import { FieldType } from 'enums/FieldTypeEnums';

interface Stage0Props {
  isDisabled?: boolean;
}

export const getStage0Data = (props: Stage0Props) => {
  const { isDisabled } = props;
  const { LABELS, FIELD_NAMES } = STAGE0;
  const { COMMODITY_NAME, REPORTING_YEAR, ALLOCATION_LABEL } = LABELS;
  const { REPORTING_YEAR_NAME, PRODUCT_NAME_NAME, FARM_REVENUE_NAME } =
    FIELD_NAMES;
  return {
    data: [
      {
        type: FieldType.INPUT,
        fieldProps: {
          name: PRODUCT_NAME_NAME,
          label: COMMODITY_NAME,
          placeholderstring: COMMODITY_NAME,
          disabled: isDisabled,
        },
        span: 24,
      },
      {
        type: FieldType.INPUT,
        fieldProps: {
          name: REPORTING_YEAR_NAME,
          label: REPORTING_YEAR,
          placeholderstring: REPORTING_YEAR,
          disabled: true,
        },
        span: 24,
      },
      {
        type: FieldType.INPUT,
        fieldProps: {
          name: FARM_REVENUE_NAME,
          label: ALLOCATION_LABEL,
          placeholderstring: ALLOCATION_LABEL,
          disabled: isDisabled,
        },
        span: 24,
      },
    ],
  };
};
